export default __webpack_public_path__ + "static/media/fortmatic.0c2bc25a.svg";